
import { defineComponent } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { dispatch } = useStore()
    const quitVARS = () => dispatch("callgate/quitVARS")
    return {
      quitVARS,
    }
  },
})
